import React from 'react';

export const UserContext = React.createContext();

export const ErrorContext = React.createContext();

export const AdminContext = React.createContext();
